"use strict";
module.exports = function () {
    var sizes = ["xs", "sm", "md", "lg", "xl"];

    sizes.forEach(function (size) {
        const selector = ".collapsible-" + size + " .title";

        $("body").on("click", selector, function (e) {
            e.preventDefault();
            const $this = $(this);

            $this.closest(".collapsible-" + size).toggleClass("active");

            if ($this.closest(".collapsible-" + size).hasClass("active")) {
                $this.attr("aria-expanded", true);
            } else {
                $this.attr("aria-expanded", false);
            }
        });
    });
};
